import { Editor } from 'tinymce';
import { GraphqlService } from 'src/app/_core/services/graphql.service';
import { Store } from '@ngxs/store';
import { UserState } from 'src/app/_user/store/user/user.state';
import { MutationUploaderImageFromRichTextBoxArgs } from 'src/graphql/generated-types';
import gql from 'graphql-tag';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


export class SharedEditorUploadImageButton {
    constructor(private readonly editor: Editor,
                private readonly store: Store,
                private readonly graphqlService: GraphqlService) {
        this.registerButton();
    }

    private get hasModuleEditAvance(): boolean {
        return this.store?.selectSnapshot(UserState.hasModules('EDITAVANCE'));
    }

    private uploadImage(file: string, filename: string): void {
        this.graphqlService.mutateOne<'UploaderImageFromRichTextBox', MutationUploaderImageFromRichTextBoxArgs>({
            mutation: gql`
                mutation UploaderImageFromRichTextBox(
                    $contexte: ContextInfosInput,
                    $nomFichier: String,
                    $fichier: String
                ) {
                    UploaderImageFromRichTextBox(
                        contexte: $contexte,
                        nomFichier: $nomFichier,
                        fichier: $fichier
                    ) {
                        Filename,
                        Url
                    }
                }
            `,
            variables: {
                nomFichier: filename,
                fichier: file
            }
        }).pipe(
            tap(retour => this.editor.insertContent('<img src="' + retour.Url + '">'))
        ).subscribe();
    }

    private registerButton(): void {
        if (!!this.hasModuleEditAvance) {
            const serviceInstance = this;
            this.editor.ui.registry.addButton('imageupload', {
                icon: 'image',
                tooltip: 'Insérer une image',
                onAction: function (_) {
                    serviceInstance.editor.focus();
                    var input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', environment.extensions.img.join(','));

                    input.onchange = function () {
                        var file = input.files[0];
                        var reader = new FileReader();
                        reader.onload = function () {
                            var base64 = ('' + reader.result).split(',')[1];
                            serviceInstance.uploadImage(base64, file.name);
                        };
                        reader.readAsDataURL(file);
                    };

                    input.click();
                },
            });
        }
    }
}
